/* tslint:disable */
import { StudEqpPrm } from './stud-eqp-prm';

/**
 */
export class ViewTrCalculate {
    ldSetpointmax?: number;
    idStudyEquipment?: number;
    trPrm?: StudEqpPrm;
    tsPrm?: StudEqpPrm;
    vcPrm?: StudEqpPrm;
    tePrm?: StudEqpPrm;
    equipName?: string;
    trMin?: number;
    trMax?: number;
    tsMin?: number;
    tsMax?: number;
    disabled?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-tr-calculate.ts